import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Per-user persisted state. Remembers a VA's last-used filters, tabs, etc.
export function useStickyState(key, defaultValue) {
  const { user } = useAuth();
  const storageKey = `avy:${user?.id || "anon"}:${key}`;
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* ignore */ }
  }, [storageKey, value]);
  return [value, setValue];
}
